var _desc, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    stroke: "#2329D6",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#2329D6",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "dropIconTitle"
  }, "Drop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "dropIconTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "dropIconDesc"
  }, "Icon of a single liquid drop")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,21 C15.3137085,21 18,18.3904147 18,15 C18,11.6666667 16,8 12,4 C8,8 6,11.6666667 6,15 C6,18.3904147 8.6862915,21 12,21 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.6ad311e6ad26b36ea561860677bb1331.svg";
export { ForwardRef as ReactComponent };